module.exports = __webpack_public_path__ + "static/media/home-studio.88689020.jpg";